<div class="container-fluid" style="margin-right: 0; padding-right: 0;">
      <div class="row flex-column-reverse flex-lg-row ms-lg-3">
        <div class="col-lg-5">
          <label class="header-text-bold mt-4">Let's find you a dentist</label>
          <br>
          <div class="d-flex mt-3 mb-1">
            <input #searchBox type="text" class="form-control" style="width: 63%" placeholder="Address, City, or Zip" id="location">
            <div class="btn btn-lg" (click)="findLocations()" id="dentistButton">find a dentist</div>
          </div>
          <label class="footer-info-text" *ngIf="!showResults">Zoom in to see results</label>
          <div class="row" *ngIf="showResults" >
            <div id="dentist-listings" class="col-12 mt-4" style="overflow-y: scroll; overflow-x: hidden; height: 550px;">
              <app-location-card *ngFor="let marker of markers;let i = index" >
                <div id="marker{{i+1}}" class="row">
                  <div class="col-12">
                    <span class="me-2 ellipse"><span class="item-num">{{marker.label}}</span></span><label class="card-header-text">{{marker.practice.title}}</label>
                  </div>
                  <div class="col-12 ms-5">
                    <div class="street-address">{{marker.practice.address.line1}} {{marker.practice.address.line2}}</div>
                    <div class="street-address">{{marker.practice.address.city}}, {{marker.practice.address.state}} {{marker.practice.address.zipCode}}</div>
                    <hr style="width: 85%">
                    <div class="street-address">{{marker.practice.phone | phone}} | <a href="{{marker.practice.url}}" (click)="clickDentistWebsite()">Website</a></div>
                  </div>
                </div>
              </app-location-card>
            </div>
          </div>
        </div>
        <div class="col-lg-7" style="margin: 0; padding: 0;">
          <div class="map-container" id="mapContainerDiv">
            <google-map #mapContainer
                height="700px"
                width="100%"
                [center]="center"
                [zoom]="zoom"
                [mapId]="mapId"
                [options]="mapOptions">
                <div *ngIf="showResults">
                  <map-advanced-marker #markerElem="mapAdvancedMarker" *ngFor="let marker of markers;let i = index;"
                    [position]="marker.position"
                    [title]="marker.practice.title"
                    (mapClick)="onMarkerClick(markerElem,marker)"
                    [content]="marker.content"
                    >
                  </map-advanced-marker>
                </div>
              <map-info-window #infoWindow class="iw-container"></map-info-window>
            </google-map>
          </div>
        </div>
</div>

